import React, { useEffect, useState } from "react";
import "../style/homeCategory.css";
import { Link } from "react-router-dom";
import { getcategory } from "../service/category.service";
import { getlistingUrl } from "../../../utils/url.utils";

export default function HomeCategory() {
  const [categoryItems, setCategoryItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchCategories();
  }, []);

 const fetchCategories = async () => {
  try {
    setLoading(true);
    const response = await getcategory();
    const data = response.map((item) => ({
      id: item.id,
      title: item.title,
      alt: item.media?.[0]?.altText || item.title,
      src: item.media?.[0]?.image,
      buttonUrl: item.buttonUrl || item.slug,
    }));

    setCategoryItems(data);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  if (loading) {
    return (
      <section className="category-section mt-2">
        <div className="container text-center">
          Loading...
        </div>
      </section>
    );
  }

  const firstImg = categoryItems.find(
    (item) => item.title === "Bath Care"
  );

  const carpetImg = categoryItems.find(
    (item) => item.title === "Carpet"
  );

  const dustbinImg = categoryItems.find(
    (item) => item.title === "Dustbins"
  );

  const bottomLeftImgs = categoryItems.filter(
    (item) =>
      item.id !== firstImg?.id &&
      item.id !== carpetImg?.id &&
      item.id !== dustbinImg?.id
  );

  if (!loading && HomeCategory?.length) return null;

  return (
    <section className="category-section mt-2 wow animate__animated animate__fadeInRight">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2>CATEGORIES</h2>
            <div className="border-bootemline"></div>
          </div>
        </div>

        <div className="row g-3">
         {/* Left */}
          <div className="col-md-8">
            {carpetImg && ( 
              <div className="relative overflow-hidden border-radius-44" style={{ borderRadius: "14px", height: "100%" }}>
                  <Link to={getlistingUrl(carpetImg.buttonUrl)}>
                    <img
                      src={carpetImg.src}
                      alt={carpetImg.alt}
                      className="w-100 h-100"
                      style={{ objectFit: "cover" }}
                      className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110"
                    />
                    <span className='category-subheading'>
                      {carpetImg.title}
                    </span>
                  </Link>
                </div>
            )}
          </div>

          {/* Right */}
          <div className="col-md-4">
            {dustbinImg && (
                <div className="relative overflow-hidden border-radius-44" style={{ borderRadius: "14px", height: "100%" }}>
                  <Link to={getlistingUrl(firstImg.buttonUrl)}>
                    <img
                        src={firstImg.src}
                        alt={firstImg.alt}
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                        className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110"
                    />
                    <span className='category-subheading'>  {firstImg.title} </span>
                  </Link>
                </div>
                )}
          </div>

          <div className="col-md-12 mt-3">
            <div className="row g-3">
              {/* Dustbin */}
              <div className="col-md-4">
                {dustbinImg && (
                   <div className="relative overflow-hidden border-radius-44" style={{ borderRadius: "14px", height: "100%" }}>
                    <Link to={getlistingUrl(dustbinImg.buttonUrl)}>
                      <img
                        src={dustbinImg.src}
                        alt={dustbinImg.alt}
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                        className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110"
                      />
                      <span className="category-subheading">
                        {dustbinImg.title}
                      </span>
                    </Link>
                  </div>
                )}
              </div>

              {/* Remaining Categories */}
              <div className="col-md-8">
                <div className="row g-3">
                  {bottomLeftImgs.map((item) => (
                    <div className="col-md-6" key={item.id}>
                       <div className="relative overflow-hidden border-radius-44" style={{ borderRadius:"14px", height:"100%" }}>
                        <Link to={getlistingUrl(item.buttonUrl)}>
                          <img
                            src={item.src}
                            alt={item.alt}
                            className="w-100 h-100"
                            style={{ objectFit: "cover" }}
                            className="w-100 h-100 object-cover transition duration-300 ease-in-out hover:scale-110"
                          />
                          <span className="category-subheading">
                            {item.title}
                          </span>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </section>
  );
}